import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../../services/api.service';
@Component({
  selector: 'app-compare',
  templateUrl: './compare.component.html',
  styleUrls: ['./compare.component.css']
})
export class CompareComponent implements OnInit {

  maximized: boolean = false;
  year_select = parseInt(new DatePipe('en-US').transform(new Date(), 'yyyy')!) + 543;
  btn_pdf: boolean = false;
  data_years = [] as any;
  data_plan = [] as any;
  data_result = [] as any;
  sumCol: any;
  select_plan = {
    principle: [] as any,
    revenue: [] as any,
    expend: {
      invest: {
        loan: [] as any,
        sup: [] as any,
      },
      personal: [] as any,
      oper: [] as any,
      out: [] as any
    },
    last: [] as any
  }
  sum_revenue = {
    type3: 'รวมรายรับทั้งสิ้น',
    plan: {
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0,
      sumRow: 0,
      per_q1: 0,
      per_q2: 0,
      per_q3: 0,
      per_q4: 0,
      per_sum: 0
    },
    result: {
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0,
      sumRow: 0,
      per_q1: 0,
      per_q2: 0,
      per_q3: 0,
      per_q4: 0,
      per_sum: 0
    },
  }
  sum_ex_sup = {
    type3: 'รวมรายจ่าย - เงินสนับสนุนโครงการฯ',
    plan: {
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0,
      sumRow: 0,
      per_q1: 0,
      per_q2: 0,
      per_q3: 0,
      per_q4: 0,
      per_sum: 0
    },
    result: {
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0,
      sumRow: 0,
      per_q1: 0,
      per_q2: 0,
      per_q3: 0,
      per_q4: 0,
      per_sum: 0
    },
  }
  sum_ex_oper = {
    type3: 'รวมรายจ่าย - ดำเนินงาน',
    plan: {
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0,
      sumRow: 0,
      per_q1: 0,
      per_q2: 0,
      per_q3: 0,
      per_q4: 0,
      per_sum: 0
    },
    result: {
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0,
      sumRow: 0,
      per_q1: 0,
      per_q2: 0,
      per_q3: 0,
      per_q4: 0,
      per_sum: 0
    },
  }
  sum_ex = {
    type3: 'รวมรายจ่ายทั้งสิ้น',
    plan: {
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0,
      sumRow: 0,
      per_q1: 0,
      per_q2: 0,
      per_q3: 0,
      per_q4: 0,
      per_sum: 0
    },
    result: {
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0,
      sumRow: 0,
      per_q1: 0,
      per_q2: 0,
      per_q3: 0,
      per_q4: 0,
      per_sum: 0
    },
  }
  rev_exp = {
    type3: 'รายรับ - รายจ่าย',
    plan: {
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0,
      sumRow: 0,
      per_q1: 0,
      per_q2: 0,
      per_q3: 0,
      per_q4: 0,
      per_sum: 0
    },
    result: {
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0,
      sumRow: 0,
      per_q1: 0,
      per_q2: 0,
      per_q3: 0,
      per_q4: 0,
      per_sum: 0
    },
  }

  constructor(
    public services: ApiService
  ) { }

  ngOnInit(): void {
    this.getDataAll();
    document.getElementById('plans')!.classList.toggle("active");
    document.getElementById('plan')!.classList.toggle("show");
    document.getElementById('compare')!.classList.toggle("active");

  }

  ngOnDestroy() {
    document.getElementById('plans')!.classList.remove("active");
    document.getElementById('plan')!.classList.remove("show");
    document.getElementById('compare')!.classList.remove("active");
  }


  async select_year(year: any) {
    this.sum_revenue = {
      type3: 'รวมรายรับทั้งสิ้น',
      plan: {
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0,
        sumRow: 0,
        per_q1: 0,
        per_q2: 0,
        per_q3: 0,
        per_q4: 0,
        per_sum: 0
      },
      result: {
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0,
        sumRow: 0,
        per_q1: 0,
        per_q2: 0,
        per_q3: 0,
        per_q4: 0,
        per_sum: 0
      },
    }
    this.sum_ex_sup = {
      type3: 'รวมรายจ่าย - เงินสนับสนุนโครงการฯ',
      plan: {
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0,
        sumRow: 0,
        per_q1: 0,
        per_q2: 0,
        per_q3: 0,
        per_q4: 0,
        per_sum: 0
      },
      result: {
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0,
        sumRow: 0,
        per_q1: 0,
        per_q2: 0,
        per_q3: 0,
        per_q4: 0,
        per_sum: 0
      },
    }
    this.sum_ex_oper = {
      type3: 'รวมรายจ่าย - ดำเนินงาน',
      plan: {
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0,
        sumRow: 0,
        per_q1: 0,
        per_q2: 0,
        per_q3: 0,
        per_q4: 0,
        per_sum: 0
      },
      result: {
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0,
        sumRow: 0,
        per_q1: 0,
        per_q2: 0,
        per_q3: 0,
        per_q4: 0,
        per_sum: 0
      },
    }
    this.sum_ex = {
      type3: 'รวมรายจ่ายทั้งสิ้น',
      plan: {
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0,
        sumRow: 0,
        per_q1: 0,
        per_q2: 0,
        per_q3: 0,
        per_q4: 0,
        per_sum: 0
      },
      result: {
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0,
        sumRow: 0,
        per_q1: 0,
        per_q2: 0,
        per_q3: 0,
        per_q4: 0,
        per_sum: 0
      },
    }
    this.rev_exp = {
      type3: 'รายรับ - รายจ่าย',
      plan: {
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0,
        sumRow: 0,
        per_q1: 0,
        per_q2: 0,
        per_q3: 0,
        per_q4: 0,
        per_sum: 0
      },
      result: {
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0,
        sumRow: 0,
        per_q1: 0,
        per_q2: 0,
        per_q3: 0,
        per_q4: 0,
        per_sum: 0
      },
    }
    //เงินต้นงวด
    let p_principle = [] as any;
    let r_principle = [] as any;
    //รายรับ
    let p_revenue = {
      budget: [] as any,
      incom: [] as any,
      lr: [] as any
    };
    let r_revenue = {
      budget: [] as any,
      incom: [] as any,
      lr: [] as any
    };
    //รายจ่าย
    let p_expend = {
      invest: {
        loan: [] as any,
        sup: [] as any,
      },
      personal: [] as any,
      oper: [] as any,
      out: [] as any
    };
    let r_expend = {
      invest: {
        loan: [] as any,
        sup: [] as any,
      },
      personal: [] as any,
      oper: [] as any,
      out: [] as any
    };
    //เงินปลายงวด
    let p_last = [] as any;
    let r_last = [] as any;
    let p_sumRow = 0
    let r_sumRow = 0
    //แยกข้อมูลที่ตรงตามปีงบประมาณเข้าตัวแปร
    await this.data_plan.reverse().forEach(async (plan: any) => {
      p_sumRow = [parseFloat(plan.oct), parseFloat(plan.nov), parseFloat(plan.dec), parseFloat(plan.jan), parseFloat(plan.feb), parseFloat(plan.mar),
      parseFloat(plan.apr), parseFloat(plan.may), parseFloat(plan.jun), parseFloat(plan.jul), parseFloat(plan.aug), parseFloat(plan.sep)].reduce((a, b) => a + b, 0);
      plan.sumRow = this.fixDecimal(p_sumRow);
      this.calQuarter(plan);
      if (plan.fiscal_year == year) {
        if (plan.type1 == 'เงินต้นงวด') {
          p_principle.push(plan);
        } else if (plan.type1 == 'รายรับ') {
          switch (plan.type2) {
            case 'เงินงบประมาณ': {
              p_revenue.budget.push(plan);
              break;
            }
            case 'รายรับจากการดำเนินงาน': {
              p_revenue.incom.push(plan);
              break;
            }
            default: {
              p_revenue.lr.push(plan);
              break;
            }
          }
        } else if (plan.type1 == 'รายจ่าย') {
          switch (plan.type2) {
            case 'เงินกู้ยืม/อุดหนุน': {
              p_expend.invest.loan.push(plan);
              break;
            }
            case 'เงินให้สนับสนุน': {
              p_expend.invest.sup.push(plan);
              break;
            }
            case 'ค่าใช้จ่ายบุคลากร': {
              p_expend.personal.push(plan);
              break;
            }
            case 'ค่าใช้จ่ายดำเนินงาน': {
              p_expend.oper.push(plan);
              break;
            }
            case 'ค่าใช้จ่ายอื่น': {
              p_expend.out.push(plan);
              break;
            }
            default: {
              break;
            }
          }
        } else {
          p_last.push(plan);
        }
      }
    });
    await this.data_result.reverse().forEach(async (result: any) => {
      r_sumRow = [parseFloat(result.oct), parseFloat(result.nov), parseFloat(result.dec), parseFloat(result.jan), parseFloat(result.feb), parseFloat(result.mar),
      parseFloat(result.apr), parseFloat(result.may), parseFloat(result.jun), parseFloat(result.jul), parseFloat(result.aug), parseFloat(result.sep)].reduce((a, b) => a + b, 0);
      result.sumRow = this.fixDecimal(r_sumRow);
      this.calQuarter(result);
      if (result.fiscal_year == year) {
        if (result.type1 == 'เงินต้นงวด') {
          r_principle.push(result);
        } else if (result.type1 == 'รายรับ') {
          switch (result.type2) {
            case 'เงินงบประมาณ': {
              r_revenue.budget.push(result);
              break;
            }
            case 'รายรับจากการดำเนินงาน': {
              r_revenue.incom.push(result);
              break;
            }
            default: {
              r_revenue.lr.push(result);
              break;
            }
          }
        } else if (result.type1 == 'รายจ่าย') {
          switch (result.type2) {
            case 'เงินกู้ยืม/อุดหนุน': {
              r_expend.invest.loan.push(result);
              break;
            }
            case 'เงินให้สนับสนุน': {
              r_expend.invest.sup.push(result);
              break;
            }
            case 'ค่าใช้จ่ายบุคลากร': {
              r_expend.personal.push(result);
              break;
            }
            case 'ค่าใช้จ่ายดำเนินงาน': {
              r_expend.oper.push(result);
              break;
            }
            case 'ค่าใช้จ่ายอื่น': {
              r_expend.out.push(result);
              break;
            }
            default: {
              break;
            }
          }
        } else {
          r_last.push(result);
        }
      }
    });

    //map plan & result
    //calculate percentage
    this.select_plan.principle = await this.mapData(p_principle, r_principle)
    this.select_plan.principle.forEach(async (data: any) => {
      await this.calPercent(data);
    });
    this.select_plan.last = await this.mapData(p_last, r_last)
    this.select_plan.last.forEach(async (data: any) => {
      await this.calPercent(data);
    });
    for (let x = 0; x < r_revenue.budget.length; x++) {
      if (p_revenue.budget.length < r_revenue.budget.length) {
        p_revenue.budget.push({
          id: 0,
          fiscal_year: 0,
          type1: '',
          type2: '',
          type3: '',
          oct: 0,
          nov: 0,
          dec: 0,
          jan: 0,
          feb: 0,
          mar: 0,
          apr: 0,
          may: 0,
          jun: 0,
          jul: 0,
          aug: 0,
          sep: 0,
          q1: 0,
          q2: 0,
          q3: 0,
          q4: 0,
          sumRow: 0
        })
      }
    }
    this.select_plan.revenue.budget = await this.mapData(p_revenue.budget, r_revenue.budget)
    this.select_plan.revenue.budget.forEach(async (data: any) => {
      this.calSumCol(data)
    });
    this.select_plan.revenue.budget.push(this.sumCol)
    this.createSumCol('รวมรายรับจากการดำเนินงาน	');
    this.select_plan.revenue.budget.forEach(async (data: any) => {
      await this.calPercent(data);
      await this.calSum(data.plan, 'revenue', 'plan');
      await this.calSum(data.result, 'revenue', 'result');
      this.fixNumber(data)
    });

    for (let x = 0; x < r_revenue.incom.length; x++) {
      if (p_revenue.incom.length < r_revenue.incom.length) {
        p_revenue.incom.push({
          id: 0,
          fiscal_year: 0,
          type1: '',
          type2: '',
          type3: '',
          oct: 0,
          nov: 0,
          dec: 0,
          jan: 0,
          feb: 0,
          mar: 0,
          apr: 0,
          may: 0,
          jun: 0,
          jul: 0,
          aug: 0,
          sep: 0,
          q1: 0,
          q2: 0,
          q3: 0,
          q4: 0,
          sumRow: 0
        })
      }
    }
    this.select_plan.revenue.incom = await this.mapData(p_revenue.incom, r_revenue.incom)
    this.select_plan.revenue.incom.forEach(async (data: any) => {
      this.calSumCol(data)
    });
    this.select_plan.revenue.incom.push(this.sumCol)
    this.createSumCol('รวมเงินรับคืนและรายรับอื่นจากโครงการจัดรูปที่ดิน');
    this.select_plan.revenue.incom.forEach(async (data: any) => {
      await this.calPercent(data);
      await this.calSum(data.plan, 'revenue', 'plan');
      await this.calSum(data.result, 'revenue', 'result');
      this.fixNumber(data)
    });
    for (let x = 0; x < r_revenue.lr.length; x++) {
      if (p_revenue.lr.length < r_revenue.lr.length) {
        p_revenue.lr.push({
          id: 0,
          fiscal_year: 0,
          type1: '',
          type2: '',
          type3: '',
          oct: 0,
          nov: 0,
          dec: 0,
          jan: 0,
          feb: 0,
          mar: 0,
          apr: 0,
          may: 0,
          jun: 0,
          jul: 0,
          aug: 0,
          sep: 0,
          q1: 0,
          q2: 0,
          q3: 0,
          q4: 0,
          sumRow: 0
        })
      }
    }
    this.select_plan.revenue.lr = await this.mapData(p_revenue.lr, r_revenue.lr)
    this.select_plan.revenue.lr.forEach(async (data: any) => {
      this.calSumCol(data)
    });
    this.select_plan.revenue.lr.push(this.sumCol)
    this.createSumCol('รวมเงินลงทุน');
    this.select_plan.revenue.lr.forEach(async (data: any) => {
      await this.calPercent(data);
      await this.calSum(data.plan, 'revenue', 'plan');
      await this.calSum(data.result, 'revenue', 'result');

      this.fixNumber(data)
    });
    for (let x = 0; x < r_expend.invest?.loan.length; x++) {
      if (p_expend.invest?.loan.length < r_expend.invest?.loan.length) {
        p_expend.invest?.loan.push({
          id: 0,
          fiscal_year: 0,
          type1: '',
          type2: '',
          type3: '',
          oct: 0,
          nov: 0,
          dec: 0,
          jan: 0,
          feb: 0,
          mar: 0,
          apr: 0,
          may: 0,
          jun: 0,
          jul: 0,
          aug: 0,
          sep: 0,
          q1: 0,
          q2: 0,
          q3: 0,
          q4: 0,
          sumRow: 0
        })
      }
    }
    this.select_plan.expend.invest.loan = await this.mapData(p_expend.invest?.loan, r_expend.invest?.loan)
    this.select_plan.expend.invest.loan.forEach(async (data: any) => {
      this.calSumCol(data)
      await this.calPercent(data);
      await this.calSum(data.plan, 'ex_sup', 'plan');
      await this.calSum(data.result, 'ex_sup', 'result');

      this.fixNumber(data)
    });
    
    for (let x = 0; x < r_expend.invest?.sup.length; x++) {
      if (p_expend.invest?.sup.length < r_expend.invest?.sup.length) {
        p_expend.invest?.sup.push({
          id: 0,
          fiscal_year: 0,
          type1: '',
          type2: '',
          type3: '',
          oct: 0,
          nov: 0,
          dec: 0,
          jan: 0,
          feb: 0,
          mar: 0,
          apr: 0,
          may: 0,
          jun: 0,
          jul: 0,
          aug: 0,
          sep: 0,
          q1: 0,
          q2: 0,
          q3: 0,
          q4: 0,
          sumRow: 0
        })
      }
    }
    this.select_plan.expend.invest.sup = await this.mapData(p_expend.invest.sup, r_expend.invest.sup)
    this.select_plan.expend.invest.sup.forEach(async (data: any) => {
      this.calSumCol(data)
    });
    this.select_plan.expend.invest.sup.push(this.sumCol)
    this.createSumCol('รวมรายจ่ายบุคลากร');
    this.select_plan.expend.invest.sup.forEach(async (data: any) => {
      await this.calPercent(data);
      await this.calSum(data.plan, 'ex_sup', 'plan');
      await this.calSum(data.result, 'ex_sup', 'result');

      this.fixNumber(data)
    });
    for (let x = 0; x < r_expend.personal.length; x++) {
      if (p_expend.personal.length < r_expend.personal.length) {
        p_expend.personal.push({
          id: 0,
          fiscal_year: 0,
          type1: '',
          type2: '',
          type3: '',
          oct: 0,
          nov: 0,
          dec: 0,
          jan: 0,
          feb: 0,
          mar: 0,
          apr: 0,
          may: 0,
          jun: 0,
          jul: 0,
          aug: 0,
          sep: 0,
          q1: 0,
          q2: 0,
          q3: 0,
          q4: 0,
          sumRow: 0
        })
      }
    }
    this.select_plan.expend.personal = await this.mapData(p_expend.personal, r_expend.personal)
    this.select_plan.expend.personal.forEach(async (data: any) => {
      this.calSumCol(data)
    });
    this.select_plan.expend.personal.push(this.sumCol)
    this.createSumCol('รวมรายจ่ายการดำเนินงาน');
    this.select_plan.expend.personal.forEach(async (data: any) => {
      await this.calPercent(data);
      await this.calSum(data.plan, 'ex_oper', 'plan');
      await this.calSum(data.result, 'ex_oper', 'result');

      this.fixNumber(data)
    });
    for (let x = 0; x < r_expend.oper.length; x++) {
      if (p_expend.oper.length < r_expend.oper.length) {
        p_expend.oper.push({
          id: 0,
          fiscal_year: 0,
          type1: '',
          type2: '',
          type3: '',
          oct: 0,
          nov: 0,
          dec: 0,
          jan: 0,
          feb: 0,
          mar: 0,
          apr: 0,
          may: 0,
          jun: 0,
          jul: 0,
          aug: 0,
          sep: 0,
          q1: 0,
          q2: 0,
          q3: 0,
          q4: 0,
          sumRow: 0
        })
      }
    }
    this.select_plan.expend.oper = await this.mapData(p_expend.oper, r_expend.oper)
    this.select_plan.expend.oper.forEach(async (data: any) => {
      this.calSumCol(data)
    });
    this.select_plan.expend.oper.push(this.sumCol)
    this.createSumCol('ค่าใช้จ่ายอื่น');
    this.select_plan.expend.oper.forEach(async (data: any) => {
      await this.calPercent(data);
      await this.calSum(data.plan, 'ex_oper', 'plan');
      await this.calSum(data.result, 'ex_oper', 'result');

      this.fixNumber(data)
    });
    for (let x = 0; x < r_expend.out.length; x++) {
      if (p_expend.out.length < r_expend.out.length) {
        p_expend.out.push({
          id: 0,
          fiscal_year: 0,
          type1: '',
          type2: '',
          type3: '',
          oct: 0,
          nov: 0,
          dec: 0,
          jan: 0,
          feb: 0,
          mar: 0,
          apr: 0,
          may: 0,
          jun: 0,
          jul: 0,
          aug: 0,
          sep: 0,
          q1: 0,
          q2: 0,
          q3: 0,
          q4: 0,
          sumRow: 0
        })
      }
    }
    this.select_plan.expend.out = await this.mapData(p_expend.out, r_expend.out)
    this.select_plan.expend.out.forEach(async (data: any) => {
      this.calSumCol(data)
    });
    this.select_plan.expend.out.push(this.sumCol)
    this.createSumCol('รวมเงินงบประมาณ');
    this.select_plan.expend.out.forEach(async (data: any) => {
      await this.calPercent(data);
      await this.calSum(data.plan, 'ex_oper', 'plan');
      await this.calSum(data.result, 'ex_oper', 'result');

      this.fixNumber(data)
    });

    //cal sum expend
    this.sum_ex.plan.sumRow = this.sum_ex_sup.plan.sumRow + this.sum_ex_oper.plan.sumRow;
    this.sum_ex.plan.q1 = this.sum_ex_sup.plan.q1 + this.sum_ex_oper.plan.q1;
    this.sum_ex.plan.q2 = this.sum_ex_sup.plan.q2 + this.sum_ex_oper.plan.q2;
    this.sum_ex.plan.q3 = this.sum_ex_sup.plan.q3 + this.sum_ex_oper.plan.q3;
    this.sum_ex.plan.q4 = this.sum_ex_sup.plan.q4 + this.sum_ex_oper.plan.q4;
    this.sum_ex.result.sumRow = this.sum_ex_sup.result.sumRow + this.sum_ex_oper.result.sumRow;
    this.sum_ex.result.q1 = this.sum_ex_sup.result.q1 + this.sum_ex_oper.result.q1;
    this.sum_ex.result.q2 = this.sum_ex_sup.result.q2 + this.sum_ex_oper.result.q2;
    this.sum_ex.result.q3 = this.sum_ex_sup.result.q3 + this.sum_ex_oper.result.q3;
    this.sum_ex.result.q4 = this.sum_ex_sup.result.q4 + this.sum_ex_oper.result.q4;

    //cal revenue - expend
    this.rev_exp.plan.sumRow = this.sum_revenue.plan.sumRow - this.sum_ex.plan.sumRow;
    this.rev_exp.plan.q1 = this.sum_revenue.plan.q1 - this.sum_ex.plan.q1;
    this.rev_exp.plan.q2 = this.sum_revenue.plan.q2 - this.sum_ex.plan.q2;
    this.rev_exp.plan.q3 = this.sum_revenue.plan.q3 - this.sum_ex.plan.q3;
    this.rev_exp.plan.q4 = this.sum_revenue.plan.q4 - this.sum_ex.plan.q4;
    this.rev_exp.result.sumRow = this.sum_revenue.result.sumRow - this.sum_ex.result.sumRow;
    this.rev_exp.result.q1 = this.sum_revenue.result.q1 - this.sum_ex.result.q1;
    this.rev_exp.result.q2 = this.sum_revenue.result.q2 - this.sum_ex.result.q2;
    this.rev_exp.result.q3 = this.sum_revenue.result.q3 - this.sum_ex.result.q3;
    this.rev_exp.result.q4 = this.sum_revenue.result.q4 - this.sum_ex.result.q4;

    this.sum_revenue = await this.calPercent(this.sum_revenue);
    this.sum_ex_sup = await this.calPercent(this.sum_ex_sup);
    this.sum_ex_oper = await this.calPercent(this.sum_ex_oper);
    this.sum_ex = await this.calPercent(this.sum_ex);
    this.rev_exp = await this.calPercent(this.rev_exp);

    //fix 0 to null
    this.sum_revenue = await this.fixNumber(this.sum_revenue);
    this.sum_ex_sup = await this.fixNumber(this.sum_ex_sup);
    this.sum_ex_oper = await this.fixNumber(this.sum_ex_oper);
    this.sum_ex = await this.fixNumber(this.sum_ex);
    this.rev_exp = await this.fixNumber(this.rev_exp);

  }

  async getDataAll() {
    this.data_plan = []
    this.data_result = []
    this.createSumCol('รวมเงินงบประมาณ');
    await this.services.get('m_plan').then((plan: any) => {
      plan.forEach(async (p: any) => {
        if (p.status == 'Enable') {
          await this.data_years.push(parseInt(p.fiscal_year));
          await this.data_plan.push(p);
        }
      });
    })
    await this.services.get('m_result').then((result: any) => {
      result.forEach(async (r: any) => {
        if (r.status == 'Enable') {
          await this.data_result.push(r);
        }
      });
    })
    this.data_years = [...new Set(this.data_years)].sort();
    this.select_year(this.year_select);
  }

  async calQuarter(data: any) {
    data.q1 = this.fixDecimal(parseFloat(data.oct) + parseFloat(data.nov) + parseFloat(data.dec))
    data.q2 = this.fixDecimal(parseFloat(data.jan) + parseFloat(data.feb) + parseFloat(data.mar))
    data.q3 = this.fixDecimal(parseFloat(data.apr) + parseFloat(data.may) + parseFloat(data.jun))
    data.q4 = this.fixDecimal(parseFloat(data.jul) + parseFloat(data.aug) + parseFloat(data.sep))
    return data;
  }

  //func Round decimal
  fixDecimal(x: any) {
    if (x == 0 || x == null) {
      return 0
    } else {
      return Math.round(x * 100) / 100;
    }
  }
  //func create variable sumCol
  createSumCol(data: any) {
    this.sumCol = {
      plan: {
        id:0.1,
        type3: data,
        sumRow: 0,
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0
      },
      result: {
        type3: data,
        sumRow: 0,
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0
      }
    }
    return this.sumCol;
  }
  //func calculate sum column
  calSumCol(data: any) {
    this.sumCol.plan.q1 += Number(data.plan.q1);
    this.sumCol.plan.q2 += Number(data.plan.q2);
    this.sumCol.plan.q3 += Number(data.plan.q3);
    this.sumCol.plan.q4 += Number(data.plan.q4);
    this.sumCol.plan.sumRow += Number(data.plan.sumRow);

    this.sumCol.result.q1 += Number(data.result.q1);
    this.sumCol.result.q2 += Number(data.result.q2);
    this.sumCol.result.q3 += Number(data.result.q3);
    this.sumCol.result.q4 += Number(data.result.q4);
    this.sumCol.result.sumRow += Number(data.result.sumRow);
    return this.sumCol;
  }
  mapData(plan: any, result: any) {
    const data = plan.map(function (value: any, index: any) {
      if (value.id != 0) {
        return {
          plan: value,
          result: result[index]
        }
      }
      else {
        return {
          plan: {
            id: 0,
            fiscal_year: result[index].fiscal_year,
            type1: result[index].type1,
            type2: result[index].type2,
            type3: result[index].type3,
            oct: 0,
            nov: 0,
            dec: 0,
            jan: 0,
            feb: 0,
            mar: 0,
            apr: 0,
            may: 0,
            jun: 0,
            jul: 0,
            aug: 0,
            sep: 0,
            q1: 0,
            q2: 0,
            q3: 0,
            q4: 0,
            sumRow: 0
          },
          result: result[index]
        }
      }
    });
    return data
  }
  //func calculat percentage
  calPercent(data: any) {
    if (data.plan.sumRow == 0) {
      data.plan.per_sum = 0
      data.plan.per_q1 = 0
      data.plan.per_q2 = 0
      data.plan.per_q3 = 0
      data.plan.per_q4 = 0

      data.result.per_sum = 0
      data.result.per_q1 = 0
      data.result.per_q2 = 0
      data.result.per_q3 = 0
      data.result.per_q4 = 0
    } else {
      data.plan.per_sum = this.fixDecimal((data.plan.sumRow / data.plan.sumRow) * 100).toFixed(0)
      data.plan.per_q1 = this.fixDecimal((data.plan.q1 / data.plan.sumRow) * 100).toFixed(0)
      data.plan.per_q2 = this.fixDecimal((data.plan.q2 / data.plan.sumRow) * 100).toFixed(0)
      data.plan.per_q3 = this.fixDecimal((data.plan.q3 / data.plan.sumRow) * 100).toFixed(0)
      data.plan.per_q4 = this.fixDecimal((data.plan.q4 / data.plan.sumRow) * 100).toFixed(0)

      data.result.per_sum = this.fixDecimal((data.result.sumRow / data.plan.sumRow) * 100).toFixed(0)
      data.result.per_q1 = this.fixDecimal((data.result.q1 / data.plan.sumRow) * 100).toFixed(0)
      data.result.per_q2 = this.fixDecimal((data.result.q2 / data.plan.sumRow) * 100).toFixed(0)
      data.result.per_q3 = this.fixDecimal((data.result.q3 / data.plan.sumRow) * 100).toFixed(0)
      data.result.per_q4 = this.fixDecimal((data.result.q4 / data.plan.sumRow) * 100).toFixed(0)
    }
    return data;
  }
  calSumPer(data: any) {

  }
  //func convert 0 to null
  fixNumber(data: any) {
    data.plan.sumRow = this.checkNull(data.plan.sumRow)
    data.plan.q1 = this.checkNull(data.plan.q1)
    data.plan.q2 = this.checkNull(data.plan.q2)
    data.plan.q3 = this.checkNull(data.plan.q3)
    data.plan.q4 = this.checkNull(data.plan.q4)

    data.result.sumRow = this.checkNull(data.result.sumRow)
    data.result.q1 = this.checkNull(data.result.q1)
    data.result.q2 = this.checkNull(data.result.q2)
    data.result.q3 = this.checkNull(data.result.q3)
    data.result.q4 = this.checkNull(data.result.q4)
    return data;
  }
  //func fix 0 to null
  checkNull(x: any) {
    if (x == 0) {
      return null;
    }
    else {
      return parseFloat(x);
      //return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }

  calSumRevenue(data: any, type: any) {
    if (type == 'plan') {
      this.sum_revenue.plan.q1 += parseFloat(data.q1)
      this.sum_revenue.plan.q2 += parseFloat(data.q2)
      this.sum_revenue.plan.q3 += parseFloat(data.q3)
      this.sum_revenue.plan.q4 += parseFloat(data.q4)
      this.sum_revenue.plan.sumRow += parseFloat(data.sumRow)
    } else {
      this.sum_revenue.result.q1 += parseFloat(data.q1)
      this.sum_revenue.result.q2 += parseFloat(data.q2)
      this.sum_revenue.result.q3 += parseFloat(data.q3)
      this.sum_revenue.result.q4 += parseFloat(data.q4)
      this.sum_revenue.result.sumRow += parseFloat(data.sumRow)
    }
  }
  calSum(data: any, type: any, path: any) {
    if (type == 'revenue') {
      if (path == 'plan') {
        this.sum_revenue.plan.q1 += parseFloat(data.q1)
        this.sum_revenue.plan.q2 += parseFloat(data.q2)
        this.sum_revenue.plan.q3 += parseFloat(data.q3)
        this.sum_revenue.plan.q4 += parseFloat(data.q4)
        this.sum_revenue.plan.sumRow += parseFloat(data.sumRow)
      } else {
        this.sum_revenue.result.q1 += parseFloat(data.q1)
        this.sum_revenue.result.q2 += parseFloat(data.q2)
        this.sum_revenue.result.q3 += parseFloat(data.q3)
        this.sum_revenue.result.q4 += parseFloat(data.q4)
        this.sum_revenue.result.sumRow += parseFloat(data.sumRow)
      }
    } else if (type == 'ex_sup') {
      if (path == 'plan') {
        this.sum_ex_sup.plan.q1 += parseFloat(data.q1)
        this.sum_ex_sup.plan.q2 += parseFloat(data.q2)
        this.sum_ex_sup.plan.q3 += parseFloat(data.q3)
        this.sum_ex_sup.plan.q4 += parseFloat(data.q4)
        this.sum_ex_sup.plan.sumRow += parseFloat(data.sumRow)
      } else {
        this.sum_ex_sup.result.q1 += parseFloat(data.q1)
        this.sum_ex_sup.result.q2 += parseFloat(data.q2)
        this.sum_ex_sup.result.q3 += parseFloat(data.q3)
        this.sum_ex_sup.result.q4 += parseFloat(data.q4)
        this.sum_ex_sup.result.sumRow += parseFloat(data.sumRow)
      }
    } else if (type == 'ex_oper') {
      if (path == 'plan') {
        this.sum_ex_oper.plan.q1 += parseFloat(data.q1)
        this.sum_ex_oper.plan.q2 += parseFloat(data.q2)
        this.sum_ex_oper.plan.q3 += parseFloat(data.q3)
        this.sum_ex_oper.plan.q4 += parseFloat(data.q4)
        this.sum_ex_oper.plan.sumRow += parseFloat(data.sumRow)
      } else {
        this.sum_ex_oper.result.q1 += parseFloat(data.q1)
        this.sum_ex_oper.result.q2 += parseFloat(data.q2)
        this.sum_ex_oper.result.q3 += parseFloat(data.q3)
        this.sum_ex_oper.result.q4 += parseFloat(data.q4)
        this.sum_ex_oper.result.sumRow += parseFloat(data.sumRow)
      }
    }
  }

  //full page table
  maximizeorMinimize(table: any, btn: any) {
    this.services.maximizeorMinimize(table, btn, this.maximized)
    this.maximized = this.services.switchMaximize(this.maximized);
  }
  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
  onClickListMenu() {
    document.getElementById('finances')!.classList.remove('active');
    document.getElementById('finance')!.classList.remove('show');
    // document.getElementById('plans')!.classList.remove('active');
    document.getElementById('plan')!.classList.remove('show');
    document.getElementById('receivables')!.classList.remove('active');
    document.getElementById('receivable')!.classList.remove('show');
  }
}
